<div class="wrapper wrapper-dark">
  <div class="title-section mb-5">{{"La storia"|translate}}</div>

  <div class="p-relative first-box">
    <img src="./assets/img/1.gif" class="history-img">

    <div class="light-box border-green box-history">
      {{"HISTORY_1"|translate}}
      <br><br>
      {{"HISTORY_2"|translate}}
    </div>
  </div>

  <div class="p-relative second-box">
    <img src="./assets/img/2.gif" class="history-img">

    <div class="light-box border-green box-history">
      {{"HISTORY_3"|translate}}
      <br><br>
      {{"HISTORY_4"|translate}}
      <br><br>
      {{"HISTORY_5"|translate}}
    </div>
  </div>


  <div class="p-relative third-box">
    <img src="./assets/img/3.jfif" class="history-img">

    <div class="light-box border-green box-history">
      {{"HISTORY_6"|translate}}
      <br><br>
      {{"HISTORY_7"|translate}}
      <br><br>
      {{"HISTORY_8"|translate}}
    </div>
  </div>
</div>